export default __webpack_public_path__ + "ce66b0f1034b9b9d2caa2c4813f7e6e1.mp3";